export default "__VITE_ASSET__ff26a84a__"